import DashboardIcon from "@mui/icons-material/Dashboard";
import BusinessIcon from "@mui/icons-material/Business";
import HistoryIcon from "@mui/icons-material/History";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import HowToRegIcon from "@mui/icons-material/HowToReg";

export const adminModulesList = [
  {
    title: "Home",
    icon: DashboardIcon,
    path: "/admin-dashboard",
  },
  {
    title: "Users",
    icon: BusinessIcon,
    path: "/admin-dashboard/clients",
  },
  {
    title: "Approvals",
    icon: HowToRegIcon,
    path: "/admin-dashboard/approvals",
  },
  {
    title: "Notifications",
    icon: ReportProblemIcon,
    path: "/admin-dashboard/notifications",
  },
  {
    title: "Admin Logs",
    icon: HistoryIcon,
    path: "/admin-dashboard/logs",
  },
];
